<script lang="ts">
  window["C"].APP_NAME = "demo";
  import Footer from "@shared/svelte/Components/Layout/Footer.svelte";
  import GoogleTranslate from "@modern/components/shared/GoogleTranslate.svelte";
  import Header from "@shared/svelte/Components/Layout/DemoHeader.svelte";

  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";

  import bootstrap from "@modern/services/boot/bootstrap";

  import { onMount } from "svelte";
  import { goto, page, url } from "@roxi/routify";

  onMount(async () => {
    await bootstrap({ $page, $url, $goto });
    DistributorsStore.set([]);
  });
</script>

<div class=" fizz-styles">
  <Header />
  <slot />

  <Footer />
  <GoogleTranslate />
</div>

<div id="programmatic-modal-container" class="fizz-styles"></div>
